// @ts-nocheck
/**
* ATTENTION!
* @generated THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
*/

import * as Types from '../schema';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type ArchiveAiChatSessionMutationVariables = Types.Exact<{
  sessionId: Types.Scalars['ID']['input'];
}>;


export type ArchiveAiChatSessionMutation = { __typename?: 'Mutation', archiveAiChatSession: { __typename?: 'AiChatSession', id: string, workspaceId: string, scopeType: Types.AiChatScopeType, status: Types.AiChatSessionStatus, scopeDocumentCollectionId?: string | null, title: string, createdAt: any, updatedAt: any } };


export const ArchiveAiChatSessionDocument = gql`
    mutation ArchiveAiChatSession($sessionId: ID!) {
  archiveAiChatSession(sessionId: $sessionId) {
    id
    workspaceId
    scopeType
    status
    scopeDocumentCollectionId
    title
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useArchiveAiChatSessionMutation__
 *
 * To run a mutation, you first call `useArchiveAiChatSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveAiChatSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveAiChatSessionMutation, { data, loading, error }] = useArchiveAiChatSessionMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useArchiveAiChatSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchiveAiChatSessionMutation, ArchiveAiChatSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ArchiveAiChatSessionMutation, ArchiveAiChatSessionMutationVariables>(ArchiveAiChatSessionDocument, options);
      }
export type ArchiveAiChatSessionMutationHookResult = ReturnType<typeof useArchiveAiChatSessionMutation>;
export type ArchiveAiChatSessionMutationResult = ApolloReactCommon.MutationResult<ArchiveAiChatSessionMutation>;